<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('data_import_logs.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openDataImportLogForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetDataImportLogs(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="data_import_logs" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openDataImportLogForm(props.item)">
                                <td>{{ props.item.import_id }}</td>
                                <td>{{ props.item.file_name }}.{{ props.item.file_type }}</td>
                                <td class="text-center">{{ props.item.table_name }}</td>
                                <td class="text-center">{{ props.item.total_records_imported }}</td>
                                <td class="text-center">{{ props.item.created_by }}</td>
                                <td class="text-center">{{ props.item.date_created }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="data_import_logs"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="data_import_log_dialog">
                <v-card>
                    <v-form ref="form_data_import_log">
                        <v-card-title>
                            <span class="headline">{{ data_import_log.import_id ? $t("lang.edit_data_import_log") : $t("lang.add_data_import_log") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeDataImportLogDialog"
                                :dialog-status="data_import_log_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="data_import_log_dialog"
                                            v-model="data_import_log.import_id"
                                            :label="$t('lang.import_id')"
                                            :counter="showCounter(data_import_log.import_id, 'data_import_logs.import_id')"
                                            :rules="ifValid('data_import_logs.import_id')"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            :label="`${$t('lang.file_name')} *`"
                                            :counter="showCounter(data_import_log.file_name, 'data_import_logs.file_name')"
                                            :rules="ifValid('data_import_logs.file_name')"
                                            :value="`${data_import_log.file_name}.${data_import_log.file_type}`"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="data_import_log.table_name" :label="`${$t('lang.table_name')}`" readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="data_import_log.total_records_imported"
                                            :label="`${$t('lang.total_records_imported')}`"
                                            readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="data_import_log.created_by" :label="`${$t('lang.uploaded_by')}`" readonly></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="data_import_log.date_created" :label="`${$t('lang.date_created')}`" readonly></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                v-if="data_import_log.import_id && isDateCreatedValid(data_import_log.date_created)"
                                color="error"
                                @mouseup.left="$refs.delete_data_import_logs.openDialog()"
                                >{{ $t("lang.delete") }}</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeDataImportLogDialog()">{{ $t("lang.cancel") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_data_import_logs"
                :heading="$t('lang.delete_data_import_log')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteDataImportLogs(data_import_log.import_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openDataImportLogForm" },
                { title: this.$t("lang.refresh"), action: "dbGetDataImportLogs", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.import_id"), sortable: false, width: "15%" },
                { text: this.$t("lang.file_name"), sortable: false, width: "25%" },
                { text: this.$t("lang.table_name"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.total_records_imported"), sortable: false, align: "center", width: "10%" },
                { text: this.$t("lang.uploaded_by"), sortable: false, align: "center", width: "20%" },
                { text: this.$t("lang.date_created"), sortable: false, align: "center", width: "15%" },
            ],
            enableAddModal: false,
            enableEditModal: true,

            data_import_log: {},
            filter: {
                search: "",
            },
            data_import_log_dialog: false,
            dbGetDataImportLogs: _.debounce(this.getDataImportLogs, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchDataImportLogs", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.data_import_logs) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchDataImportLogs({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.data_import_logs) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.data_import_logs.data_import_logs_filter,
            page: (state) => state.data_import_logs.page,
            rules_data_import_logs: (state) => state.data_import_logs.rules_data_import_logs,
            data_import_log_status_options: (state) => state.settings.data_import_log_status_options,
            data_import_logs: (state) => state.data_import_logs.data_import_logs,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDataImportLogs", "saveDataImportLog", "deleteDataImportLog"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openDataImportLogForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_data_import_log) item ? this.$refs.form_data_import_log.resetValidation() : this.$refs.form_data_import_log.reset();

                    this.$nextTick(() => {
                        this.data_import_log = item != null ? this.assignObj2(item, this.rules_data_import_logs) : {};
                        this.data_import_log_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "data_import_log", params: { id: item.import_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_data_import_log) item ? this.$refs.form_data_import_log.resetValidation() : this.$refs.form_data_import_log.reset();
                    this.data_import_log_dialog = true;
                } else {
                    this.$router.push({ name: "data_import_log" });
                }
            }
        },
        saveDataImportLogs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_data_import_log")) {
                    let body = this.prepForm(this.data_import_log, this.rules_data_import_logs);

                    this.saveDataImportLog({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getDataImportLogs();
                                this.closeDataImportLogDialog();
                            } else {
                                this.$router.push({ name: "data_import_log", params: { id: data.import_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteDataImportLogs(id = null) {
            this.deleteDataImportLog({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getDataImportLogs();
                    this.closeDataImportLogDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeDataImportLogDialog() {
            this.data_import_log_dialog = false;
            this.$refs.delete_data_import_logs.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getDataImportLogs(pg_refresh = false) {
            this.startLoader();

            this.fetchDataImportLogs({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.data_import_log_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        isDateCreatedValid(dateCreated) {
            const currentDate = new Date();
            const adjustedCurrentDate = new Date(currentDate.getTime() - 4 * 60 * 60 * 1000);
            const importDate = new Date(dateCreated);

            return importDate >= adjustedCurrentDate;
        },
    },
};
</script>
